import React, { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { inititatePasswordReset } from "../../redux/actions/auth/reset";
import { setLargeToast } from "../../redux/actions/toastNotification/toastNotification";
import { INIT_PWD_RESET } from "../../redux/actionTypes/actionsTypes";
import { InitResetPassword } from "../../redux/reducers/getAuthReducer/resetPasswordReducer";
import { RootState } from "../../redux/reducers/root";
import extractFormData from "../../utils/extractFormData";
import AmpButton from "../common/AmpButton/AmpButton";
import AmpCaptcha from "../common/AmpCaptcha/AmpCaptcha";
import AmpFormError from "../common/AmpFormError/AmpFormError";
import AmpInput from "../common/AmpInput/AmpInput";
import AmpLoadingSpinner from "../common/AmpLoadingSpinner/AmpLoadingSpinner";
import SmallHeading from "../common/AmpSmallHeading/AppSmallHeading";

interface ResetStep2Props {
    question: string,
    userProfileId: string,
    email: string,
    cancel: () => void
}

export default function ResetStep2(props: ResetStep2Props) {
    
    const { t } = useTranslation("login");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const resetStore = useSelector((state: RootState) => state.authReducer.reset.begin as InitResetPassword);

    const [wrongAnswer, setWrongAnswer] = useState(false);
    const [errorOccured, setErrorOccured] = useState(false);
    const [answer, setAnswer] = useState("");
    const [lastA, setLastAnswer] = useState("");
    const [captchaKey, setCaptchaKey] = useState(1);
    const [noAnswer, setNoAnswer] = useState(false);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setLastAnswer(answer)
        setWrongAnswer(false);
        setErrorOccured(false);
        setCaptchaKey(captchaKey + 1);
        dispatch({type: INIT_PWD_RESET.RESET});
        if (answer === "") {
            setNoAnswer(true);
            return;
        }
        const data = extractFormData(e);
        const payload = {
            "user_profile_id": props.userProfileId,
            "security_a": data["answer"] as string,
            ...data
        }
        dispatch(inititatePasswordReset(payload));
    }

    useEffect(() => {
        if (resetStore.token && !resetStore.loading) {
            navigate(`/auth/reset/${props.userProfileId}/${props.email}/${resetStore.token}`)

            dispatch(setLargeToast(t("5-large-toast"), "success", true));
        } else if (!resetStore.answer_correct && !resetStore.loading){
            setWrongAnswer(true);
        } else if (resetStore.reset_failed) {
            setErrorOccured(true)
        }
    }, [resetStore, navigate, props, dispatch, t])

    const cancel = (e: FormEvent) => {
        e.preventDefault();
        props.cancel();
    }
    const answerChanged = lastA !== answer;
    const error = wrongAnswer && answer ? t("answer-wrong") : errorOccured ? "Error Occured, Please contact us." : false;

    useEffect(() => {
        if(answer !== "") {
            setNoAnswer(false);
        }
    }, [answer])

    return (
        <div className="reset-container">
            <div className="reset-header">
                {t("3-sec") as string}
            </div>
            <AmpLoadingSpinner loading={resetStore.loading}>
                <form className="reset-content-top" onSubmit={(e) => { handleSubmit(e) }}>
                    <div className="reset-content">
                        <SmallHeading for={"reset-answer"}>
                            {props.question}
                        </SmallHeading>
                        <AmpInput type="text" name="answer" id="reset-answer" noTimer={true} onInput={(e) => {setAnswer(e)}}/>
                        <AmpInput type="hidden" name="user_profile_id" id="reset-uuid" value={props.userProfileId} />
                        <AmpInput type="hidden" name="question" id="reset-q" value={props.question} />
                        <AmpCaptcha key={captchaKey}/>
                        <AmpFormError error={(wrongAnswer || errorOccured) && !answerChanged} errorMessage={error as string} />
                        <AmpFormError error={noAnswer} errorMessage={t("enter-answer")} />
                    </div>
                    <div className="login-container-footer">
                        <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                        <div>
                            <AmpButton type="cancel" onClick={(e) => cancel(e)} text={t("cancel")} />
                            <AmpButton type="submit" onClick={() => null} text={t("submit")} />
                        </div>
                    </div>
                </form>
            </AmpLoadingSpinner>
        </div>
    )

}